import { SubscriptionCredentials } from '../../domain/credentials/SubscriptionCredentials';
import { SubscriptionCredentialsDTO } from '../../domain/credentials/SubscriptionCredentialsDTO';

export class SubscriptionCredentialsMapper {
  static toDomain(props: SubscriptionCredentialsDTO): SubscriptionCredentials {
    return SubscriptionCredentials.create({
      active: props.active,
      items: props.items,
    });
  }
}
